import styled from "styled-components";
import { RATypography, RAButtonPrimary, RAButtonSecondary } from "@/components/customs";
import { Row, Col, Divider } from "antd";
import { AirportLegInfo } from "../molecules";
import { SvgInfoFill } from "@/assets/icons";
import { initFormAirFreight } from "@/utils/initializing";
import { formatPhoneNumberIntl } from "react-phone-number-input";
import { HeaderSection } from "../ui/Cards";

export function FormAirFreightSummary({ data = initFormAirFreight, onBack, onSubmitRequest, loading }) {
	const _renderGeneralInfo = () => {
		return (
			<WrapperFlightInfo>
				<CardInfo title="General Information" />
				<CardItem label="Company/Name" value={data?.company_name ?? "_"} />
				<CardItem label="Contact name" value={data?.contact?.name ?? "_"} />
				<CardItem label="Email" value={data?.contact?.email ?? "_"} />
				<CardItem
					label="Phone"
					value={data?.contact?.phone ? formatPhoneNumberIntl(data?.contact?.phone) : "_"}
				/>
				<CardItem label="Additional Notes" value={data?.note ?? "_"} />
			</WrapperFlightInfo>
		);
	};

	const _renderCargoInfo = () => {
		return (
			<WrapperFlightInfo>
				<CardInfo title="Cargo Information" />
				<CardItem label="Quantity" value={data?.cargo_info?.quantity ?? "_"} />
				<CardItem label="Weight (lb)" value={data?.cargo_info?.weight_lb ?? "_"} />
				<CardItem label="Height (inches)" value={data?.cargo_info?.heigh_inch ?? "_"} />
				<CardItem label="Width (inches)" value={data?.cargo_info?.width_inch ?? "_"} />
				<CardItem label="Length (inches)" value={data?.cargo_info?.length_inch ?? "_"} />
			</WrapperFlightInfo>
		);
	};

	return (
		<ContainerRequestFlight>
			<HeaderSection title="Summary" />
			<Divider />
			<WrapperLegInfo className="ra-box-d">
				<AirportLegInfo from_airport={data?.from_airport} to_airport={data?.to_airport} />
			</WrapperLegInfo>
			{_renderGeneralInfo()}
			{_renderCargoInfo()}
			<Row gutter={[20, 12]} justify="center" align="middle" style={{ marginTop: "40px" }}>
				<Col>
					<RAButtonSecondary
						data-testid="airFreightSummary_backBtn"
						title="BACK"
						onClick={() => onBack()}
						width="140px"
					/>
				</Col>
				<Col>
					<RAButtonPrimary
						data-testid="airFreightSummary_submitBtn"
						title="SUBMIT"
						onClick={() => onSubmitRequest()}
						width="140px"
						loading={loading}
					/>
				</Col>
			</Row>
		</ContainerRequestFlight>
	);
}

const CardItem = ({ label = "", value = "" }) => (
	<Row align="top">
		<Col xl={6} lg={8} md={12} xs={24}>
			<RATypography variant="body3" color="#595959">
				{label}
			</RATypography>
		</Col>
		<Col xl={18} lg={16} md={12} xs={24}>
			<RATypography variant="sub-heading4" color="#222222">
				{value}
			</RATypography>
		</Col>
	</Row>
);

const CardInfo = ({ title }) => (
	<WrapperCardInfo>
		<IconContainer>
			<SvgInfoFill color="#FFB11A" />
		</IconContainer>
		<RATypography variant="label3">{title}</RATypography>
	</WrapperCardInfo>
);

const WrapperFlightInfo = styled.div`
	margin-top: 20px;
	display: flex;
	flex-direction: column;
	gap: 16px;
	padding: 20px;
	width: 100%;
	background: #fafafa;
	border-radius: 12px;
`;
const WrapperLegInfo = styled.div`
	width: 100%;
	padding: 16px 20px;
	gap: 16px;
	min-height: 72px;
	border: 1px dashed #e9e8e8;
	border-radius: 10px;
`;
const ContainerRequestFlight = styled.div`
	width: "100%";
	@media (max-width: 576px) {
		.ant-divider-horizontal {
			margin: 16px 0px;
		}
	}
`;
const IconContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 8px;
	background-color: #f3f2f2;
	border-radius: 50%;
`;
const WrapperCardInfo = styled.div`
	display: flex;
	align-items: center;
	gap: 12px;
	margin-bottom: 4px;
`;
